// src/logger/index.js
import debug from 'debug';
import { useRef } from 'react';

/**
 * Tạo logger dạng `app:scope1:scope2:...`
 * @param  {...string} scopes
 * @returns {Function} logger
 */
export function createScopedLogger(...scopes) {
  const namespace = [...scopes].join(':');
  return debug(namespace);
}

/**
 * Hook dùng trong function component
 * @param  {...string} scopes
 * @returns {Function} logger
 */
export function useScopedLogger(...scopes) {
  const loggerRef = useRef();

  if (!loggerRef.current) {
    loggerRef.current = createScopedLogger(...scopes);
  }

  return loggerRef.current;
}

/**
 * Tạo một factory để sinh logger theo prefix sẵn
 * @param  {...string} baseScopes - Scope cố định cho module
 * @returns {Function} loggerFactory
 */
export function createLoggerFactory(...baseScopes) {
  return (...subScopes) => createScopedLogger(...baseScopes, ...subScopes);
}
